import { useIntl } from 'react-intl';
import { ChevronDown } from 'lucide';

// MUI
import AccordionSummary from '@mui/material/AccordionSummary';

// common
import Icon from 'common/components/Icon';

interface Props {
  label: string; // id dịch intl
}

/**
 * Hiển thị phân loại vai trò:
 * Vai trò nghiệp vụ | Vai trò quản trị | Vai trò hệ thống
 */
const RoleCategory = ({ label }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <AccordionSummary
      expandIcon={<Icon icon={ChevronDown} />}
      aria-controls="panel1-content"
      id={`panel${label}-header`}
      sx={{ fontSize: '14px', fontWeight: 500 }}
    >
      {formatMessage({ id: label })}
    </AccordionSummary>
  );
};

export default RoleCategory;
